import { toAssetUrl } from '../../utils/assetBase';

const BRAND = '#0090bb';

export const normalizeUrl = (raw) => {
    const s = String(raw || '').trim();
    if (!s) return '';
    if (/^https?:\/\//i.test(s)) return s;
    return `https://${s}`;
};

// — Brand SVG ikonları ——————————————————————————————————————
export const FacebookIcon = ({ className = 'h-5 w-5' }) => (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
        <path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5.02 3.66 9.18 8.44 9.94v-7.03H7.9v-2.91h2.54V9.84c0-2.52 1.49-3.91 3.78-3.91 1.1 0 2.24.2 2.24.2v2.47h-1.26c-1.24 0-1.63.78-1.63 1.57v1.89h2.77l-.44 2.91h-2.33V22c4.78-.76 8.44-4.92 8.44-9.94z" />
    </svg>
);

export const InstagramIcon = ({ className = 'h-5 w-5' }) => (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <rect x="3" y="3" width="18" height="18" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.5" cy="6.5" r="1.1" fill="currentColor" stroke="none" />
    </svg>
);

// Həftə günləri (iş saatları üçün)
export const DAY_ORDER = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
export const DAY_LABELS = {
    mon: 'Bazar ertəsi', tue: 'Çərşənbə axşamı', wed: 'Çərşənbə',
    thu: 'Cümə axşamı', fri: 'Cümə', sat: 'Şənbə', sun: 'Bazar',
};

export const WhatsAppIcon = ({ className = 'h-5 w-5' }) => (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
        <path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.945C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 018.413 3.488 11.824 11.824 0 013.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 001.512 5.26l-.999 3.648 3.476-.911zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
    </svg>
);

export const PhoneIcon = ({ className = 'h-4 w-4', style }) => (
    <svg className={className} style={style} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.86 19.86 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.86 19.86 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92z" />
    </svg>
);

export const PinIcon = ({ className = 'h-4 w-4', style }) => (
    <svg className={className} style={style} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 1 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
    </svg>
);

export const ClockIcon = ({ className = 'h-4 w-4', style }) => (
    <svg className={className} style={style} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
    </svg>
);

const ChatIcon = ({ className = 'h-4 w-4', style }) => (
    <svg className={className} style={style} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
);

const ShareIcon = ({ className = 'h-4 w-4', style }) => (
    <svg className={className} style={style} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <circle cx="18" cy="5" r="3" />
        <circle cx="6" cy="12" r="3" />
        <circle cx="18" cy="19" r="3" />
        <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
        <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
    </svg>
);

const TapHandIcon = ({ className = 'h-5 w-5' }) => (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <path d="M9 11V6a2 2 0 0 1 4 0v5" />
        <path d="M13 9V4a2 2 0 0 1 4 0v9" />
        <path d="M17 9a2 2 0 0 1 4 0v6a7 7 0 0 1-7 7h-1a8 8 0 0 1-8-8v-3a2 2 0 0 1 4 0v2" />
    </svg>
);

// — Sadə qızıl ulduz —
export const GoldStar = ({ size = 26 }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden>
        <path fill="#FBBC04" d="M12 2l2.95 5.98 6.6.96-4.77 4.65 1.13 6.57L12 17.77 6.09 20.16l1.13-6.57L2.45 8.94l6.6-.96L12 2z" />
    </svg>
);

const QrCover = ({ tenant, token, occupancy, onEnter }) => {
    const logo = tenant?.qr_cover_logo_url || tenant?.login_image_url || '';
    // Əlavə düymə (ev vitrini) — superadmin tick + ad yazıbsa görünür
    const bookingEnabled = Number(tenant?.qr_cover_booking_enabled || 0) === 1;
    const bookingLabel = String(tenant?.qr_cover_booking_label || '').trim();
    const showBooking = bookingEnabled && bookingLabel && token;
    // Banket menyu düyməsi — A-frame-dən müstəqil
    const banquetEnabled = Number(tenant?.qr_cover_banquet_enabled || 0) === 1;
    const banquetLabel = String(tenant?.qr_cover_banquet_label || '').trim();
    const showBanquet = banquetEnabled && banquetLabel && token;
    const gReviewEnabled = Number(tenant?.google_review_enabled || 0) === 1;
    const gReviewUrl = tenant?.google_review_url || '';
    const openGoogleReview = () => { if (gReviewUrl) window.open(gReviewUrl, '_blank', 'noopener,noreferrer'); };
    const twoGisUrl = String(tenant?.twogis_url || '').trim();
    const name = tenant?.name || '';
    const address = tenant?.qr_cover_address || '';
    const hours = tenant?.qr_cover_hours || '';
    const phone = tenant?.phone || '';
    const fb = normalizeUrl(tenant?.qr_cover_facebook);
    const ig = normalizeUrl(tenant?.qr_cover_instagram);
    // WhatsApp nömrəsi → wa.me beynəlxalq link
    const waDigits = String(tenant?.qr_cover_whatsapp || '').replace(/\D/g, '');
    const waIntl = waDigits ? (waDigits.startsWith('994') ? waDigits : waDigits.startsWith('0') ? '994' + waDigits.slice(1) : '994' + waDigits) : '';
    const wa = waIntl ? `https://wa.me/${waIntl}` : '';
    // Strukturlaşdırılmış iş saatları (JSON) — yoxdursa köhnə sərbəst mətnə düşür
    const hoursStruct = (() => {
        try { const j = tenant?.qr_cover_hours_json; if (j) return typeof j === 'string' ? JSON.parse(j) : j; } catch { /* yanlış JSON */ }
        return null;
    })();

    const hasSocials = fb || ig || wa;
    const hasContact = phone || address;
    // Superadmindən seçilmiş giriş fonu (şəkil). Yoxdursa standart gradient.
    const coverBg = tenant?.qr_cover_bg_url ? toAssetUrl(tenant.qr_cover_bg_url) : '';
    // Şəklin üstündəki örtük (superadmin): rəng ağ və ya brend mavisi, şəffaflıq 0-90%. Standart: ağ 20%.
    const coverOverlay = (() => {
        const th = tenant?.qr_theme || {};
        const op = Number.isFinite(Number(th.cover_overlay_opacity)) ? Number(th.cover_overlay_opacity) : 20;
        const a = Math.max(0, Math.min(90, op)) / 100;
        let rgb = '255,255,255';
        if (th.cover_overlay === 'blue') {
            const hex = String(th.primary || '#0090bb').replace('#', '');
            const full = hex.length === 3 ? hex.split('').map((c) => c + c).join('') : hex.slice(0, 6);
            const n = parseInt(full, 16);
            rgb = Number.isFinite(n) ? `${(n >> 16) & 255},${(n >> 8) & 255},${n & 255}` : '0,144,187';
        }
        // aşağıya doğru bir az güclənir (alt kartlar oxunsun)
        return `linear-gradient(180deg, rgba(${rgb},${a}) 0%, rgba(${rgb},${Math.min(0.95, a * 1.25)}) 100%)`;
    })();

    return (
        <div
            className="relative min-h-screen w-full flex flex-col items-center justify-between px-5 py-8 text-center"
            style={{
                background: coverBg
                    ? 'transparent'
                    : `radial-gradient(circle at 50% 0%, rgba(0,144,187,0.18) 0%, transparent 60%), linear-gradient(180deg, #f4f8fa 0%, #ffffff 100%)`,
                touchAction: 'manipulation',
                isolation: 'isolate' // fon qatı (z -1) məzmunun altında qalsın
            }}
        >
            {coverBg && (
                // Sabit fon qatı (scroll edəndə şəkil yerində qalır) + yazılar oxunsun deyə yumşaq ağ örtük
                <div aria-hidden="true" className="fixed inset-0 pointer-events-none" style={{ zIndex: -1 }}>
                    <div className="absolute inset-0" style={{ backgroundImage: `url("${coverBg}")`, backgroundSize: 'cover', backgroundPosition: 'center' }} />
                    <div className="absolute inset-0" style={{ background: coverOverlay }} />
                </div>
            )}
            {/* Animasiyalar */}
            <style>{`
                @keyframes qrcoverPulse {
                    0%, 100% { transform: translateY(0); box-shadow: 0 10px 30px rgba(0,144,187,0.35); }
                    50%      { transform: translateY(-4px); box-shadow: 0 18px 40px rgba(0,144,187,0.45); }
                }
                @keyframes qrcoverTap {
                    0%, 100% { transform: scale(1) rotate(0); opacity: 0.85; }
                    50%      { transform: scale(1.18) rotate(-8deg); opacity: 1; }
                }
                @keyframes qrcoverShine {
                    0%   { transform: translateX(-120%) skewX(-20deg); }
                    100% { transform: translateX(220%) skewX(-20deg); }
                }
                .qrcover-cta { animation: qrcoverPulse 2.2s ease-in-out infinite; }
                .qrcover-tap-icon { animation: qrcoverTap 1.4s ease-in-out infinite; transform-origin: 70% 70%; }
                .qrcover-shine::after {
                    content: ''; position: absolute; inset: 0;
                    background: linear-gradient(110deg, transparent 30%, rgba(255,255,255,0.35) 50%, transparent 70%);
                    animation: qrcoverShine 2.8s ease-in-out infinite;
                    pointer-events: none;
                }
            `}</style>

            <div className="flex-1 flex flex-col items-center justify-center w-full max-w-sm">
                <div className="mb-6 flex h-32 w-32 items-center justify-center overflow-hidden rounded-3xl bg-white shadow-lg sm:h-36 sm:w-36">
                    {logo ? (
                        <img
                            src={toAssetUrl(logo)}
                            alt={name}
                            className="h-full w-full object-cover"
                            onError={(e) => { e.target.style.display = 'none'; }}
                        />
                    ) : (
                        <div className="text-4xl font-black" style={{ color: BRAND }}>
                            {name ? name.charAt(0).toUpperCase() : '🍽️'}
                        </div>
                    )}
                </div>

                <div className="mb-1 text-[11px] font-semibold uppercase tracking-[0.32em] text-gray-400">
                    Xoş gəlmisiniz
                </div>
                <h1 className="mb-6 text-2xl font-black text-gray-900 sm:text-3xl">
                    {name || 'Restoran'}
                </h1>

                {/* Restoran doluluğu — menyuya baxmazdan əvvəl */}
                {occupancy && occupancy.total > 0 && (() => {
                    const p = occupancy.percent;
                    const free = Math.max(0, occupancy.total - occupancy.occupied);
                    const c = p >= 70
                        ? { br: 'border-rose-200', bg: 'bg-rose-50', tx: 'text-rose-700', bar: 'bg-rose-500' }
                        : p >= 40
                            ? { br: 'border-amber-200', bg: 'bg-amber-50', tx: 'text-amber-700', bar: 'bg-amber-500' }
                            : { br: 'border-emerald-200', bg: 'bg-emerald-50', tx: 'text-emerald-700', bar: 'bg-emerald-500' };
                    return (
                        <div className={`mb-6 rounded-2xl border ${c.br} ${c.bg} px-4 py-3`}>
                            <div className={`text-center text-sm font-black ${c.tx}`}>🍽️ Restoran {p}% doludur</div>
                            <div className="mt-0.5 text-center text-[11px] font-semibold text-gray-500">
                                {occupancy.total} masadan {occupancy.occupied} dolu · {free} boş
                            </div>
                        </div>
                    );
                })()}

                <button
                    type="button"
                    onClick={onEnter}
                    className="qrcover-cta qrcover-shine relative w-full overflow-hidden rounded-2xl px-6 py-4 text-base font-bold uppercase tracking-wider text-white transition-transform active:scale-[0.97]"
                    style={{ background: `linear-gradient(135deg, ${BRAND}, var(--qr-primary-2, #006f91))` }}
                >
                    <span className="relative z-10 inline-flex items-center justify-center gap-2.5">
                        <span>Menyuya bax</span>
                        <span className="qrcover-tap-icon inline-flex"><TapHandIcon className="h-5 w-5" /></span>
                    </span>
                </button>
                <div className="mt-2 text-[10px] uppercase tracking-[0.25em] text-gray-400">
                    Klik et — menyu açılsın
                </div>

                {/* Əlavə düymə — superadmin təyin edib (məs. "Aframelərə bax") → ev vitrini */}
                {showBooking && (
                    <a
                        href={`/evler?t=${encodeURIComponent(token)}`}
                        className="mt-3 flex w-full items-center justify-center gap-2 rounded-2xl border-2 px-6 py-3.5 text-sm font-bold uppercase tracking-wider transition-transform active:scale-[0.97]"
                        style={{ borderColor: BRAND, color: BRAND }}
                    >
                        <span>🏡</span>
                        <span>{bookingLabel}</span>
                    </a>
                )}

                {/* Banket menyu düyməsi */}
                {showBanquet && (
                    <a
                        href={`/banket?t=${encodeURIComponent(token)}`}
                        className="mt-3 flex w-full items-center justify-center gap-2 rounded-2xl border-2 px-6 py-3.5 text-sm font-bold uppercase tracking-wider transition-transform active:scale-[0.97]"
                        style={{ borderColor: BRAND, color: BRAND }}
                    >
                        <span>🍽️</span>
                        <span>{banquetLabel}</span>
                    </a>
                )}

                {/* Google rəyi — aktivdirsə: ulduzlara klik → Google "rəy yaz" səhifəsi */}
                {gReviewEnabled && gReviewUrl && (
                    <button
                        type="button"
                        onClick={openGoogleReview}
                        className="mt-6 w-full rounded-2xl border border-gray-200/80 bg-white/85 px-5 py-3.5 shadow-sm backdrop-blur transition-transform active:scale-[0.98]"
                    >
                        <div className="flex items-center justify-center gap-2">
                            {/* Google G */}
                            <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden>
                                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z" />
                                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z" />
                                <path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84z" />
                                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z" />
                            </svg>
                            <span className="text-xs font-bold text-gray-600">Google-da bizi qiymətləndirin</span>
                        </div>
                        <div className="mt-2 flex items-center justify-center gap-1">
                            {[0, 1, 2, 3, 4].map((i) => <GoldStar key={i} size={28} />)}
                        </div>
                        <div className="mt-1.5 text-[11px] font-semibold text-gray-500">
                            Ulduzlara toxunun → rəy yazın ⭐
                        </div>
                    </button>
                )}

                {/* 2GIS firma səhifəsi (superadmin link yazıbsa) */}
                {twoGisUrl && (
                    <button
                        type="button"
                        onClick={() => window.open(twoGisUrl, '_blank', 'noopener,noreferrer')}
                        className="mt-3 flex w-full items-center gap-3 rounded-2xl border border-gray-200/80 bg-white/85 px-4 py-3 text-left shadow-sm backdrop-blur transition-transform active:scale-[0.98]"
                    >
                        <img src="/2gis_icon.png" alt="2GIS" className="h-9 w-9 flex-shrink-0 rounded-xl" />
                        <span className="min-w-0 flex-1">
                            <span className="block text-sm font-bold text-gray-800">2GIS-də bizə baxın</span>
                            <span className="text-[11px] font-medium text-gray-500">Ünvan, marşrut və rəylər</span>
                        </span>
                        <span className="flex-shrink-0 rounded-full px-3 py-1.5 text-xs font-bold text-white" style={{ background: '#19AA1E' }}>Aç ↗</span>
                    </button>
                )}
            </div>

            <div className="w-full max-w-sm pt-8 space-y-4">
                {/* Bizimle elaqe saxlayin */}
                {(hasSocials || hasContact) && (
                    <div className="rounded-2xl border border-gray-200/70 bg-white/85 px-5 py-4 text-left shadow-sm backdrop-blur">
                        <div className="mb-3 flex items-center gap-2 text-sm font-bold text-gray-800">
                            <ChatIcon className="h-4 w-4" style={{ color: BRAND }} />
                            <span>Bizimlə əlaqə saxlayın</span>
                        </div>

                        {phone && (
                            <div className="flex items-center justify-between gap-3 border-t border-gray-100 py-2.5 text-sm">
                                <span className="flex items-center gap-2 text-gray-500">
                                    <PhoneIcon className="h-4 w-4" style={{ color: BRAND }} />
                                    <span>Telefon:</span>
                                </span>
                                <a href={`tel:${phone}`} className="font-semibold hover:underline" style={{ color: BRAND }}>
                                    {phone}
                                </a>
                            </div>
                        )}

                        {address && (
                            <div className="flex items-start justify-between gap-3 border-t border-gray-100 py-2.5 text-sm">
                                <span className="flex items-center gap-2 text-gray-500 flex-shrink-0">
                                    <PinIcon className="h-4 w-4" style={{ color: BRAND }} />
                                    <span>Ünvan:</span>
                                </span>
                                <span className="text-right font-medium text-gray-700 leading-snug">{address}</span>
                            </div>
                        )}

                        {hasSocials && (
                            <div className="flex items-center justify-between gap-3 border-t border-gray-100 py-2.5 text-sm">
                                <span className="flex items-center gap-2 text-gray-500">
                                    <ShareIcon className="h-4 w-4" style={{ color: BRAND }} />
                                    <span>Sosial:</span>
                                </span>
                                <div className="flex items-center gap-2">
                                    {fb && (
                                        <a href={fb} target="_blank" rel="noopener noreferrer"
                                            className="flex h-9 w-9 items-center justify-center rounded-full text-white shadow-sm transition-all hover:scale-110 hover:shadow-md"
                                            style={{ backgroundColor: '#1877F2' }}
                                            title="Facebook">
                                            <FacebookIcon className="h-5 w-5" />
                                        </a>
                                    )}
                                    {ig && (
                                        <a href={ig} target="_blank" rel="noopener noreferrer"
                                            className="flex h-9 w-9 items-center justify-center rounded-full text-white shadow-sm transition-all hover:scale-110 hover:shadow-md"
                                            style={{ background: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)' }}
                                            title="Instagram">
                                            <InstagramIcon className="h-4 w-4" />
                                        </a>
                                    )}
                                    {wa && (
                                        <a href={wa} target="_blank" rel="noopener noreferrer"
                                            className="flex h-9 w-9 items-center justify-center rounded-full text-white shadow-sm transition-all hover:scale-110 hover:shadow-md"
                                            style={{ backgroundColor: '#25D366' }}
                                            title="WhatsApp">
                                            <WhatsAppIcon className="h-5 w-5" />
                                        </a>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {/* Iş saatları — strukturlu (hər gün / günlərə görə) və ya köhnə sərbəst mətn */}
                {(hoursStruct || hours) && (
                    <div className="rounded-2xl border border-gray-200/70 bg-white/85 px-5 py-4 text-left shadow-sm backdrop-blur">
                        <div className="mb-2 flex items-center gap-2 text-sm font-bold text-gray-800">
                            <ClockIcon className="h-4 w-4" style={{ color: BRAND }} />
                            <span>İş saatları</span>
                        </div>
                        {hoursStruct ? (
                            hoursStruct.mode === 'everyday' ? (
                                <div className="flex items-center justify-between gap-3 border-t border-gray-100 pt-2.5 text-sm">
                                    <span className="text-gray-500">Hər gün:</span>
                                    <span className="font-semibold text-gray-700">{hoursStruct.everyday?.open || '—'} – {hoursStruct.everyday?.close || '—'}</span>
                                </div>
                            ) : (
                                <div className="border-t border-gray-100 pt-1.5">
                                    {DAY_ORDER.map((k) => {
                                        const d = hoursStruct.days?.[k] || {};
                                        return (
                                            <div key={k} className="flex items-center justify-between gap-3 py-1 text-sm">
                                                <span className="text-gray-500">{DAY_LABELS[k]}</span>
                                                {d.on
                                                    ? <span className="font-semibold text-gray-700">{d.open || '—'} – {d.close || '—'}</span>
                                                    : <span className="font-semibold text-red-400">Bağlı</span>}
                                            </div>
                                        );
                                    })}
                                </div>
                            )
                        ) : (
                            <div className="flex items-center justify-between gap-3 border-t border-gray-100 pt-2.5 text-sm">
                                <span className="text-gray-500">Açıq saatlar:</span>
                                <span className="font-semibold text-gray-700">{hours}</span>
                            </div>
                        )}
                    </div>
                )}

                <div className="mt-2 flex flex-col items-center gap-1.5">
                    <a
                        href="https://www.fiscalbusiness.net"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[10px] uppercase tracking-[0.2em] text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        Powered by Fiscal POS
                    </a>
                    <div className="flex items-center gap-1.5 text-[10px] font-semibold text-gray-500">
                        <span>Made in Azerbaijan</span>
                        <svg className="h-3.5 w-6 rounded-sm shadow-sm" viewBox="0 0 60 30" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                            <rect width="60" height="10" y="0"  fill="#0092BC" />
                            <rect width="60" height="10" y="10" fill="#EF3340" />
                            <rect width="60" height="10" y="20" fill="#509E2F" />
                            {/* Crescent — outer circle white, offset inner circle red cuts shape */}
                            <circle cx="28" cy="15" r="3.4" fill="#fff" />
                            <circle cx="29.2" cy="15" r="2.8" fill="#EF3340" />
                            {/* 8-point star approximation */}
                            <g fill="#fff" transform="translate(33.5,15)">
                                <polygon points="0,-2.2 0.5,-0.5 2.2,0 0.5,0.5 0,2.2 -0.5,0.5 -2.2,0 -0.5,-0.5" />
                            </g>
                        </svg>
                    </div>
                    <a
                        href="tel:+994552611199"
                        className="text-[10px] text-gray-400 hover:underline"
                        style={{ color: BRAND }}
                    >
                        Ətraflı məlumat: 055 261 11 99
                    </a>
                </div>
            </div>
        </div>
    );
};

export default QrCover;
